var _a;
import { CLOSE_STATUS } from "./constants";
import { PHASE } from "../routeConfig";
import { InsuranceType } from "../constants";
export var APPLICATIONS = {
    DEFAULT: {
        show_email_password_reset: true,
        not_insured_link: {
            visible: true,
            show_on_search: false,
            text: (_a = {},
                _a[InsuranceType.Auto] = "My car is not insured",
                _a[InsuranceType.Home] = "I don't know",
                _a[InsuranceType.Life] = "I am not insured",
                _a),
        },
        agent_button_color: "bg-savvy text-white",
    },
    // This application ID is for the Chime beta experience Q3 of 2021
    "695d31fb-35dd-4380-a81a-a787aeba6171": {
        name: "Chime Beta",
        key: "a3e41a26-4774-43db-8d41-c021ff73d3a6",
        dev_key: "48c310e1-9efb-41f9-8476-273fa805df95",
        show_email_password_reset: false,
        agent_button_color: "bg-chime-green text-black-100",
    },
    // Chime Application ID 4/13/2022
    "fe1011f0-9b5d-4078-b6cc-9278328b3fcc": {
        name: "Chime Application ID 4/13/2022",
        key: "a3e41a26-4774-43db-8d41-c021ff73d3a6",
        dev_key: "48c310e1-9efb-41f9-8476-273fa805df95",
        not_insured_link: {
            visible: true,
            close_status: CLOSE_STATUS.not_insured,
        },
    },
    // Rocket Application ID 8/29/2022
    "e3e9dcaa-1c42-4982-8d2c-2060c5d37d30": {
        name: "Rocket Application ID 8/29/2022",
        key: "218547d1-bb23-4c57-8903-9fce140d3a65",
        dev_key: "223df581-d07d-47f7-8ef4-c89bc699971d",
        application_logo: "/assets/images/savvy-rocket-mortgage.svg",
        application_logo_routes: [PHASE.SELECT_INSURANCE_PRODUCT],
    },
    "e1046054-f881-49c4-ba08-665b62dc8a96": {
        name: "Savvy Application ID 02/22/23",
        key: "91845f4d-5e2e-4966-a729-5db33671ea13",
        dev_key: "8c85da54-1384-495a-b86b-87e24958c05b",
        application_logo: "/assets/images/savvy-full-logo.svg",
        trellis_logo_routes: [
            PHASE.ENTER_CREDENTIALS,
            PHASE.COMPLETE,
            PHASE.QUOTE_CONSENT,
        ],
        application_logo_routes: [
            PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER,
            PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS,
            PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_RESIDENCE_STATUS,
            PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS,
            PHASE.UNLINKED_APPLICATION_HOMEOWNERS_POLICY_HOLDER,
            PHASE.UNLINKED_APPLICATION_HOMEOWNERS_INTRO,
            PHASE.SELECT_INSURANCE_PRODUCT,
            PHASE.SELECT_AUTO_ISSUER,
            PHASE.HOME_SELECT_ISSUER,
            PHASE.SAVVY_INTRO,
            PHASE.DISCLAIMER,
            PHASE.HAVE_LOGIN,
            PHASE.REMEMBER_LOGIN,
            PHASE.VERIFY_CONTACT,
            PHASE.POLICIES_LOADING,
            PHASE.QUOTE_LOADING,
            PHASE.HOME_HAVE_LOGIN,
            PHASE.HOME_REMEMBER_LOGIN,
            PHASE.HOME_ENTER_CREDENTIALS,
            PHASE.HOME_POLICIES_LOADING,
            PHASE.HOME_POLICIES_LOADED,
            PHASE.LIFECYCLE_CONSENT,
            PHASE.AGENCY_FULFILLMENT,
        ],
    },
};
